import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    if (config.method === 'get' && config.url.includes('/contactus')) {
      // Add token to headers only for GET /contacts route
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    }
    if (config.method !== 'get') {
      // Add token to headers for all non-GET requests
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    }
    // Add proper headers for file uploads
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    // Handle successful responses
    return response;
  },
  (error) => {
    // Handle errors
    if (error.response.status === 401) {
      // Handle unauthorized error
      console.log('Unauthorized');
    }
    return Promise.reject(error);
  }
);

export default api;